/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Product_TypeInputs */

const en_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Type`)
};

const es_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de producto`)
};

const fr_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de produit`)
};

const de_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkttyp`)
};

const ja_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`製品タイプ`)
};

const zh_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品类型`)
};

const ar_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع المنتج`)
};

const id_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Produk`)
};

const it_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Prodotto`)
};

const ru_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип продукта`)
};

const pt_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Produto`)
};

const ko_field_product_type = /** @type {(inputs: Field_Product_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제품 유형`)
};

/**
* | output |
* | --- |
* | "Product Type" |
*
* @param {Field_Product_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_product_type = /** @type {((inputs?: Field_Product_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Product_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_product_type(inputs)
	if (locale === "es") return es_field_product_type(inputs)
	if (locale === "fr") return fr_field_product_type(inputs)
	if (locale === "de") return de_field_product_type(inputs)
	if (locale === "ja") return ja_field_product_type(inputs)
	if (locale === "zh") return zh_field_product_type(inputs)
	if (locale === "ar") return ar_field_product_type(inputs)
	if (locale === "id") return id_field_product_type(inputs)
	if (locale === "it") return it_field_product_type(inputs)
	if (locale === "ru") return ru_field_product_type(inputs)
	if (locale === "pt") return pt_field_product_type(inputs)
	return ko_field_product_type(inputs)
});